export default __webpack_public_path__ + "img/d3c2da146d6312e391878b489d468d61.svg";